export default __webpack_public_path__ + "static/media/ms6208b.9285e619.png";